import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface OrganizationFinanceBook {
  id: string;
  code: string;
  name: string;
  currencyCode: string;
}

export interface OrganizationBudgetAvailability {
  budgetLineId: string;
  availableAmount: number;
  revisedBudgetAmount: number;
  activeCommitmentAmount: number;
  actualAmount: number;
}

export interface OrganizationCapabilitySetting {
  capabilityKey: string;
  isEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class OrganizationFinanceApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/financial-core`;

  listBooks(): Observable<OrganizationFinanceBook[]> {
    return this.http.get<OrganizationFinanceBook[]>(`${this.base}/books`);
  }

  getBudgetAvailability(budgetLineId: string): Observable<OrganizationBudgetAvailability> {
    return this.http.get<OrganizationBudgetAvailability>(`${this.base}/budget-availability`, { params: { budgetLineId } });
  }

  getCapabilitySetting(capabilityKey: string): Observable<OrganizationCapabilitySetting> {
    return this.http.get<OrganizationCapabilitySetting>(`${this.base}/capabilities/settings/${encodeURIComponent(capabilityKey)}`);
  }
}

